import { render, staticRenderFns } from "./InvitationRecord.vue?vue&type=template&id=10a5ba06&scoped=true&"
import script from "./InvitationRecord.vue?vue&type=script&lang=js&"
export * from "./InvitationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5ba06",
  null
  
)

export default component.exports